import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const promoCodeSelector = ({ promoCode }: ReducerState) => promoCode;
export const promoCodeLoadingSelector = createSelector(
  promoCodeSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
